import {
	type Product,
	type SaveProductRequest,
	apiAppBusinessProductUpsert,
	apiAppBusinessProductDelete
} from '#lib/types/generated/index.js';
import { optimisticDelete, optimisticSave } from '#lib/stores/optimistic.js';
import { writable } from 'svelte/store';

export const productStore = writable<Product[]>([]);

function toSaveProductRequest(product: Product): SaveProductRequest {
	return {
		title: product.title,
		color: product.color,
		price: product.price,
		priceOnSite: product.priceOnSite,
		priceBy: product.priceBy,
		priceMinQuantity: product.priceMinQuantity ?? 1,
		priceMaxQuantity: product.priceMaxQuantity ?? 1,
		isMandatory: product.isMandatory,
		isRecommended: product.isRecommended,
		applyOnAllBookings: product.applyOnAllBookings,
		sortOrder: product.sortOrder,
		applyOnActivities: product.applyOnActivities,
		applyOnOffers: product.applyOnOffers,
		applyOnSessions: product.applyOnSessions,
		description: product.description,
		photo: product.photo,
		validPaxMin: product.validPaxMin,
		validPaxMax: product.validPaxMax,
		validityDates: product.validityDates
	};
}

export function saveProduct(product: Product): Promise<Product> {
	return optimisticSave(productStore, product, () =>
		apiAppBusinessProductUpsert(product.id, toSaveProductRequest(product))
	);
}

export async function deleteProduct(product: Product): Promise<void> {
	await optimisticDelete(productStore, product, () => apiAppBusinessProductDelete(product.id));
}
